import axios from 'axios';
import { API_URL } from '../config/apiConfig';


// Get client data report (all members, no date filtering)
export const getClientDataReport = async (selectedFields) => {
    try {
        const token = localStorage.getItem("token");

        const fieldsParam = selectedFields && selectedFields.length > 0
            ? selectedFields.join(',')
            : '';

        const response = await axios.get(`${API_URL}/reports/client-data`, {
            params: {
                fields: fieldsParam
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching client data report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch client data report"
        };
    }
};

// Get new users report (members created in selected date range)
export const getNewUsersReport = async (startDate, endDate, selectedFields) => {
    try {
        const token = localStorage.getItem("token");

        const fieldsParam = selectedFields && selectedFields.length > 0
            ? selectedFields.join(',')
            : '';

        const response = await axios.get(`${API_URL}/reports/new-users`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                fields: fieldsParam
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching new users report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch new users report"
        };
    }
};

// Get available fields for reports
export const getAvailableFields = async (reportType) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/available-fields`, {
            params: {
                reportType: reportType
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching available fields:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch available fields"
        };
    }
};

// Add this function
export const getVisitCountReport = async (startDate, endDate, minVisits, selectedFields) => {
    try {
        const token = localStorage.getItem("token");

        const fieldsParam = selectedFields && selectedFields.length > 0
            ? selectedFields.join(',')
            : '';

        const response = await axios.get(`${API_URL}/reports/visit-count`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                minVisits: minVisits,
                fields: fieldsParam
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching visit count report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch visit count report"
        };
    }
};

export const getChildrenVisitCountReport = async (startDate, endDate, minVisits, selectedFields) => {
    try {
        const token = localStorage.getItem("token");

        const fieldsParam = selectedFields && selectedFields.length > 0
            ? selectedFields.join(',')
            : '';

        const response = await axios.get(`${API_URL}/reports/children-visit-count`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                minVisits: minVisits,
                fields: fieldsParam
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching children visit count report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch children visit count report"
        };
    }
};

// Get demographics report
export const getDemographicsReport = async (filterType, filters) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.post(`${API_URL}/reports/demographics`, {
            filterType: filterType,
            filters: filters
        }, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching demographics report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch demographics report"
        };
    }
};

export const getPlanPurchaseReport = async (startDate, endDate, planId) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/plan-purchase`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                planId: planId
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching plan purchase report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch plan purchase report"
        };
    }
};

// Get class attendance report
export const getClassAttendanceReport = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/class-attendance`, {
            params: {
                startDate: startDate,
                endDate: endDate
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching class attendance report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch class attendance report"
        };
    }
};

// Get contract expiry report
export const getContractExpiryReport = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/contract-expiry`, {
            params: {
                startDate: startDate,
                endDate: endDate
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching contract expiry report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch contract expiry report"
        };
    }
};

// Get member lifetime value report
export const getMemberLTVReport = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/member-ltv`, {
            params: {
                startDate: startDate,
                endDate: endDate
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching member LTV report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch member LTV report"
        };
    }
};

// Get peak hours analysis
export const getPeakHoursAnalysis = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/peak-hours`, {
            params: {
                startDate: startDate,
                endDate: endDate
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching peak hours analysis:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch peak hours analysis"
        };
    }
};

// Get credit info report
export const getCreditInfoReport = async () => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/credit-info`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching credit info report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch credit info report"
        };
    }
};

// Get client lifecycle report
export const getClientLifecycleReport = async (startDate, endDate, abcPlanId) => {
    try {
        const token = localStorage.getItem("token");

        const params = {
            startDate: startDate,
            endDate: endDate
        };

        if (abcPlanId) {
            params.abcPlanId = abcPlanId;
        }

        const response = await axios.get(`${API_URL}/reports/client-lifecycle`, {
            params: params,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching client lifecycle report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch client lifecycle report"
        };
    }
};

// Get class type attendance report
export const getClassTypeAttendanceReport = async (startDate, endDate, classType) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/class-type-attendance`, {
            params: {
                startDate: startDate,
                endDate: endDate,
                classType: classType
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching class type attendance report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch class type attendance report"
        };
    }
};

export const getContractPriceReport = async ({ exactPrice, minPrice, maxPrice, onlyActive } = {}) => {
    try {
        const token = localStorage.getItem("token");
        const params = {};

        if (exactPrice !== undefined && exactPrice !== null && exactPrice !== '') {
            params.exactPrice = exactPrice;
        }
        if (minPrice !== undefined && minPrice !== null && minPrice !== '') {
            params.minPrice = minPrice;
        }
        if (onlyActive !== undefined && onlyActive !== null) {
            params.onlyActive = onlyActive;
        }
        if (maxPrice !== undefined && maxPrice !== null && maxPrice !== '') {
            params.maxPrice = maxPrice;
        }

        const response = await axios.get(`${API_URL}/reports/contract-price`, {
            params,
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching contract price report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch contract price report"
        };
    }
};

export const getPaymentHolidayReport = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/payment-holiday`, {
            params: {
                startDate,
                endDate
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching payment holiday report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch payment holiday report"
        };
    }
};

export const getRevenueAnalysisReport = async (startDate, endDate) => {
    try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${API_URL}/reports/revenue-analysis`, {
            params: {
                startDate: startDate,
                endDate: endDate
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        return response.data;
    } catch (error) {
        console.error("❌ Error fetching revenue analysis report:", error);
        return {
            success: false,
            error: error.response?.data?.error || "Failed to fetch revenue analysis report"
        };
    }
};